// extracted by mini-css-extract-plugin
module.exports = {"root":"common-link_root__2VBT4","disabled":"common-link_disabled__10RPW"};